module.exports = new __parcel__URL__("unassigned.4cbf42ba.svg").toString();